<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->

      <!-- Botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" >
        <div class="w-100">
          <div style="position: absolute;"                  
              :style="[
              zIndexModal 
                ? { 'z-index': '1 !important' }
                : { 'z-index': '-1' },
            ]"> 
            <div class="header-btn-actions">
            <agregar-acuerdo-lineas-modal
              :addAcuerdoLineasForm="addAcuerdoLineasForm"
              :idContrato="idContrato"
              :getListaAcuerdosLineas="getListaAcuerdosLineas"
            />

            <generar-acuerdo-cliente :data="tarifasRecargosRowSelected" :clear-selection="clearTariffSelection"></generar-acuerdo-cliente>

            <editar-multiple-acuerdo-lineas-modal
              :dataSeleccionada="arregloPaso"
              :acuerdoLineaArreglo="acuerdoLineaArreglo"
              :getListaAcuerdosLineas="getListaAcuerdosLineas"
              :vaciarAcuerdoLineas="vaciarAcuerdoLineas"
            />

            <duplicar-acuerdo-lineas-modal 
              :acuerdoLineaArreglo="acuerdoLineaArreglo"
              :getListaAcuerdosLineas="getListaAcuerdosLineas"
              :vaciarAcuerdoLineas="vaciarAcuerdoLineas"
            />

            <buscar-reemplazar-acuerdo-lineas-modal 
              :data="data"
              :getListaAcuerdosLineas="getListaAcuerdosLineas"
              :vaciarAcuerdoLineas="vaciarAcuerdoLineas"
              :showBuscarReemplazar="showBuscarReemplazar"
            />



            <filtro-acuerdos  
              :showBuscarReemplazar="showBuscarReemplazar"
              :data="data"
              :version="version"
            />

            <importar-csv-modal />

            <asignar-recargos-modal typeAssignRecharge="filter" :getListaAcuerdosLineas="getListaAcuerdosLineas" :tariffs="data" />
            <asignar-recargos-modal typeAssignRecharge="seleccionar" :getListaAcuerdosLineas="getListaAcuerdosLineas" :tariffs="tarifasRecargosRowSelected" />
            
            <Button class="delete-btn"
                color="#dc3545" 
                colorText="#ffffff" 
                tooltip="Eliminar seleccionados" 
                icon="fas fa-trash" 
                round 
                :width="30"  
                translate 
                :inactive="inactiveButton.deleteSelected"
                :active="false"
                @click.native="deleteBySelected()"
              />

            <Button class="delete-btn"
                color="#dc3545" 
                colorText="#ffffff" 
                tooltip="Eliminar por filtro" 
                icon="fa fa-trash-alt" 
                round 
                :width="30"  
                translate 
                :inactive="inactiveDeleteTariffLineByFilter"
                :active="false"
                @click.native="deleteByFilter()"
              />

              <Button
                :size="15"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Exportar a Excel"
                icon="icon fas fa-file-excel"
                round
                :width="30"
                class="mt-2 ml-2"
                @click.native="actionSetShowModalfilterTariffLines(true); version = 1"
                traslate
              />

              <Button
                :size="15"
                color="#0E9BAF"
                colorText="#ffffff"
                tooltip="Exportar a Excel (Versión importación)"
                icon="icon fas fa-file-excel"
                round
                :width="30"
                class="mt-2 ml-2"
                @click.native="actionSetShowModalfilterTariffLines(true); version = 3"
                traslate
              />

              <Button v-if="usuarioActual.id_country === 40"
                :size="15"
                color="#dc3545"
                colorText="#ffffff"
                tooltip="Exportar a Excel (Versión Perú)"
                icon="icon fas fa-file-excel"
                round
                :width="30"
                class="mt-2 mb-3 ml-2"
                @click.native="actionSetShowModalfilterTariffLines(true); version = 4"
                traslate
              />

              <Button v-if="usuarioActual.id_country === 8"
                :size="15"
                color="#fd7e14"
                colorText="#ffffff"
                tooltip="Exportar a Excel (Costa Rica)"
                icon="icon fas fa-file-excel"
                round
                :width="30"
                class="mt-2 mb-3 ml-2"
                @click.native="actionSetShowModalfilterTariffLines(true); version = 2"
                traslate
              />

            </div>
          </div>

          <editar-simple-acuerdo-lineas 
            v-if="editarSimpleAcuerdoLinea"
            :dataActualizar="dataAcuerdosLineasActualizar"
            :addAcuerdoLineasForm="addAcuerdoLineasForm"
            :idContrato="idContrato"
            />

            <ver-recargos-asociados 
              :id="idAcuerdo"
            />
            
            <div
              class="d-flex justify-content-center w-100"
              style="margin-top: 110px"
              v-if="loading"
            >
              <Loading />
            </div>
            <div v-else class="w-100 text-center">
              <new-data-table
                customHeaders
                v-if="acciones"
                :headers="headers"
                :data="data"
                :acciones="acciones"
                :max="10"
                paginacion
                buscar
                idtabla="lista_acuerdos_lineas"
                :seleccionar="obtenerFilaSeleccionada"
                :filaChekeada="obtenerFilaSeleccionada"
                check
                :isCustomExport="isCustomExport"
                v-model="rowsSelected"
                :vaciarArreglo="vaciarAcuerdoLineas"
              />

              <not-found-table
                v-else
                class="justify-content-center w-100 pt-5"
                :text="'No se encontraron registros de acuerdos de líneas'"
              />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import NewDataTable from "../../common/NewDataTable";
import AgregarAcuerdoLineasModal from "../../modals/lineas/tarifas/acuerdos_lineas/AgregarAcuerdoLineasModal";
import FiltroAcuerdos from "../../filtros/lineas/tarifas/FiltroAcuerdosLineas";
import EditarMultipleAcuerdoLineasModal from "../../../components/modals/lineas/tarifas/acuerdos_lineas/EditarMultipleAcuerdoLineasModal";
import EditarSimpleAcuerdoLineas from "../../modals/lineas/tarifas/acuerdos_lineas/EditarSimpleAcuerdoLineas";
import ImportarCsvModal from "../../modals/lineas/tarifas/acuerdos_lineas/ImportarCsvModal";
import AsignarRecargosModal from "../../modals/lineas/tarifas/acuerdos_lineas/AsignarRecargosModal";
import VerRecargosAsociados from "../../modals/lineas/tarifas/acuerdos_lineas/VerRecargosAsociados";
// Constantes
import { getAcuerdosLineas, deleteAcuerdoLinea, eliminarAsignacionTarifasRecargosPorTarifa, deleteManyTariffLines } from "@/constants/lineas";
// Not Found
import NotFoundTable from "../../../components/common/NotFoundTable";
import Button from '../../common/Button.vue';

// Toast
import VueToastify from "vue-toastify";
import { acuerdoLineasFormConstant } from "@/constants/forms";
import DuplicarAcuerdoLineasModal from "../../modals/lineas/tarifas/acuerdos_lineas/DuplicarAcuerdoLineasModal";
import BuscarReemplazarAcuerdoLineasModal from "../../modals/lineas/tarifas/acuerdos_lineas/BuscarReemplazarAcuerdoLineasModal";
import Loading from "../../common/loading.vue";
import GenerarAcuerdoCliente from "@/components/modals/lineas/tarifas/acuerdos_lineas/GenerarAcuerdoCliente.vue";
Vue.use(VueToastify);

export default {
  props: {
    data: { type: Array },
    getListaAcuerdosLineas: { type: Function, default: () => {} },
  },
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        { title: "ID", width: "40px" },
        { title: "Naviera", width: "40px" },
        { title: "Naviera Salida", width: "40px" },
        { title: "POL", width: "50px" },
        { title: "POD", width: "30px" },
        { title: "Desde", width: "40px" },
        { title: "Hasta", width: "30px" },
        { title: "TT", width: "10px" },
        { title: "Neta (Costo)", width: "10px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "10px" },
        { title: "Commodity", width: "90px" },
        { title: "Atmósfera", width: "35px" },
        { title: "Trat. frío", width: "35px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "2px" },
        { title: "Get Out", width: "2px" },
        { title: "Comentarios", width: "240px" },
        { title: "Tipo Contrato", width: "70px" },
        { title: "Contrato - Número", width: "70px" },
        { title: "Acciones", width: "25px" },
      ],
      acciones: [],
      dataAcuerdosLineasActualizar: [],
      dataAux: this.data,
      acuerdoLineaArreglo: [],
      indiceFinal: [],
      dataPrueba: [],
      filasDuplicadas: [],
      arregloSeleccionados: [],
      arregloPaso: [],
      isCustomExport: true,
      tarifasRecargosRowSelected: [],
      addAcuerdoLineasForm: acuerdoLineasFormConstant,
      idContrato: "",
      idAcuerdo: 0,
      showBuscarReemplazar: false,
      rowsSelected: [],
      inactiveButton: {
        deleteSelected: true,
      },
      //
      version: 1
    };
  },
  components: {
    GenerarAcuerdoCliente,
    NewDataTable,
    AgregarAcuerdoLineasModal,
    FiltroAcuerdos,
    NotFoundTable,
    EditarMultipleAcuerdoLineasModal,
    EditarSimpleAcuerdoLineas,
    DuplicarAcuerdoLineasModal,
    BuscarReemplazarAcuerdoLineasModal,
    ImportarCsvModal,
    AsignarRecargosModal,
    VerRecargosAsociados,
    Button,
    Loading,
},
  computed: {
    ...mapState([
      "loading",
      "refrescarTable",
      "puertos", 
      "contenedores",
      "tipoContratos",
      "usuarioActual"
    ]),
    ...mapState("lineas", [
      "dataListaNaviera",
      "dataListaNavierasNoUCC",
      "dataListaProducto",
      "inactiveDeleteTariffLineByFilter",
      "editarSimpleAcuerdoLinea"
    ]),
    ...mapState("administracion", ["dataDatatableAtmosferas"])
  },
  methods: {
    ...mapActions([
      "zIndexModal",
      "zIndexTablaModal"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosLineas",
      "actionSetVisibleModalEditarSimpleAcuerdoLinea",
      "actionSetVisibleModalVerRecargosAsociados",
      "actionTariffSelectedRechargeAction",
      "actionModalAsignarTarifasRecargos",
      'actionSetDataRecargosAsociados',
      "actionSetShowModalfilterTariffLines",
      "actionSetEditarSimpleAcuerdoLinea"
    ]),

    async generarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux.map((item, index) => {
        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon: "fa fa-dollar-sign",
            title: "Ver Recargos Asociados",
            id: index,
            item,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },
    async setDataEdit(fila) {
      const { data_complementaria } = this.dataAux[fila.id];
      this.addAcuerdoLineasForm.id.value = data_complementaria.contrato_id;
      this.addAcuerdoLineasForm.naviera_id.value.id   = +data_complementaria.naviera.id;
      this.addAcuerdoLineasForm.naviera_id.value.name = data_complementaria.naviera.name;
      this.addAcuerdoLineasForm.naviera_salida.value.id   = +data_complementaria.naviera_salida.id;
      this.addAcuerdoLineasForm.naviera_salida.value.name = data_complementaria.naviera_salida.name;
      this.addAcuerdoLineasForm.pol.value.id   = +data_complementaria.pol.id;
      this.addAcuerdoLineasForm.pol.value.name = data_complementaria.pol.name;
      this.addAcuerdoLineasForm.pod.value.id   = +data_complementaria.pod.id;
      this.addAcuerdoLineasForm.pod.value.name = data_complementaria.pod.name;
      this.addAcuerdoLineasForm.from_date.value = data_complementaria.from_date;
      this.addAcuerdoLineasForm.to_date.value = data_complementaria.to_date;
      this.addAcuerdoLineasForm.transit_time.value = data_complementaria.transit_time;
      this.addAcuerdoLineasForm.neta.value = this.dataAux[fila.id].data[8];
      this.addAcuerdoLineasForm.public_value.value = this.dataAux[fila.id].data[9];
      this.addAcuerdoLineasForm.container_id.value = data_complementaria.container_id;
      this.addAcuerdoLineasForm.products_category_id.value = data_complementaria.products_category_id;
      this.addAcuerdoLineasForm.atmosphere_id.value = data_complementaria.atmosphere_id;
      this.addAcuerdoLineasForm.coldtreatment.value =
        data_complementaria.coldtreatment && data_complementaria.coldtreatment !== "-"
          ? {
            id: data_complementaria.coldtreatment_id || "",
            name: data_complementaria.coldtreatment,
          }
          : { id: "", name: "" };
      this.addAcuerdoLineasForm.free_days_embark.value = data_complementaria.free_days_embark;
      this.addAcuerdoLineasForm.plug_days_embark.value = data_complementaria.plug_days_embark;
      this.addAcuerdoLineasForm.free_days_land.value = data_complementaria.free_days_land;
      this.addAcuerdoLineasForm.plug_days_land.value = data_complementaria.plug_days_land;
      this.addAcuerdoLineasForm.genset.value = data_complementaria.genset === "Si";
      this.addAcuerdoLineasForm.get_out.value = data_complementaria.get_out === "Si";
      this.addAcuerdoLineasForm.comment.value = data_complementaria.comment || "";
      this.addAcuerdoLineasForm.type_contract.value = data_complementaria.tipo_contrato;

      // COMENTARIO PARA SETEAR EL CONTRATO Y NUMERO
      this.addAcuerdoLineasForm.tariff_contract_id.value.id = +data_complementaria.tariff_contract_id.id;
      this.addAcuerdoLineasForm.tariff_contract_id.value.name = data_complementaria.tariff_contract_id.contract_number;
      this.addAcuerdoLineasForm.navieras_salida_list = data_complementaria.naviera.name === "UCC" ? this.dataListaNavierasNoUCC : [{
        id: +data_complementaria.naviera.id,
        name: data_complementaria.naviera.name
      }];

      this.actionSetEditarSimpleAcuerdoLinea(true);
    },
    vaciarAcuerdoLineas() {

      this.acuerdoLineaArreglo = [];

      this.tarifasRecargosRowSelected = [];
    },
    clearTariffSelection() {

      this.vaciarAcuerdoLineas();

    },
    async obtenerFilaSeleccionada(fila) {
      let id_contrato = fila.id;


      switch (fila.accion) {
        case "Editar":
          await this.setDataEdit(fila);
          this.idContrato = id_contrato;
          this.dataAcuerdosLineasActualizar = this.dataAux[fila.id];
          this.actionSetVisibleModalEditarSimpleAcuerdoLinea(true);
          break;

        case "Eliminar":

          if (fila.accion === "Eliminar") {

            let acuerdo_id_eliminar = this.dataAux[fila.id].data_complementaria.id_acuerdo;

            this.$vToastify.prompt(`¿Desea eliminar el Acuerdo de Línea ID - ${acuerdo_id_eliminar}?`).then((respuesta) =>
                respuesta && this.eliminarAcuerdosLineas(acuerdo_id_eliminar)
            );
          }
          break;


        case "fila_chekeada":
          if (fila.estado) {
            this.acuerdoLineaArreglo.push( this.data[fila.id].data_complementaria.contrato_id );
            this.tarifasRecargosRowSelected.push( this.data[fila.id] );
          } else {
            this.tarifasRecargosRowSelected = this.tarifasRecargosRowSelected.filter( ({ data_complementaria }) => data_complementaria.id_acuerdo !== this.data[fila.id].data_complementaria.id_acuerdo);
            this.acuerdoLineaArreglo = this.acuerdoLineaArreglo.filter(element => element !== this.data[fila.id].data_complementaria.contrato_id);
          }
          break;
        case "Ver Recargos Asociados":
          this.actionSetDataRecargosAsociados( +this.data[fila.id].data_complementaria.id_acuerdo ) ;
          this.actionSetVisibleModalVerRecargosAsociados(true);
          break;
      }
    },
    async eliminarAcuerdosLineas(id) {

      let { status, message, deleted } = await deleteAcuerdoLinea({ id });

      if (status === 200) {

        if (deleted) {

          await eliminarAsignacionTarifasRecargosPorTarifa(id);

          let dataTarifasAcuerdosLineasDB = await getAcuerdosLineas();

          this.dataAux = dataTarifasAcuerdosLineasDB.data_table;

          this.actionSetDataListarTarifasAcuerdosLineas(dataTarifasAcuerdosLineasDB.data_table);

          await this.generarBotonesAcciones();

          this.$vToastify.success(message, "¡Realizado!");

        } else {

          this.$vToastify.success(message, "¡Realizado!");

        }

      } else {

        this.$vToastify.error(message, "Error");

      }

    },
    async deleteBySelected() {

      const promptResponse = await this.$vToastify.prompt(`¿Desea eliminar ${this.rowsSelected.length} ${this.rowsSelected.length > 1 ? "elementos" : "elemento"}?`);

      if (promptResponse) {

        this.$vToastify.loader("Eliminando Registros...");

        const idsSelected = [];

        this.rowsSelected.map(id => {
          idsSelected.push({
            tableIndex: id,
            tariffId: this.dataAux[id].data_complementaria.id_acuerdo
          });
        });

        const {status, message} = await deleteManyTariffLines(idsSelected);

        if (status === 200) {

          const dataTarifasAcuerdosLineasDB = await getAcuerdosLineas();

          this.dataAux = dataTarifasAcuerdosLineasDB.data_table;

          this.actionSetDataListarTarifasAcuerdosLineas(dataTarifasAcuerdosLineasDB.data_table);

          await this.generarBotonesAcciones();

          this.$vToastify.stopLoader();

          this.$vToastify.success(message, "¡Éxito!");

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error(message, "¡Error!");
        }

      }

    },
    async deleteByFilter() {

      const promptResponse = await this.$vToastify.prompt(`¿Desea eliminar ${this.dataAux.length} ${this.dataAux.length > 1 ? "elementos" : "elemento"}?`);

      if (promptResponse) {

        this.$vToastify.loader("Eliminando Registros...");

        const idsSelected = [];

        this.dataAux.map((tariff, index) => {
          idsSelected.push({
            tableIndex: index,
            tariffId: tariff.data[0]
          });
        });

        const { status, message } = await deleteManyTariffLines(idsSelected);

        if (status === 200) {

          const dataTarifasAcuerdosLineasDB = await getAcuerdosLineas();

          this.dataAux = dataTarifasAcuerdosLineasDB.data_table;

          this.actionSetDataListarTarifasAcuerdosLineas(dataTarifasAcuerdosLineasDB.data_table);

          await this.generarBotonesAcciones();

          this.$vToastify.stopLoader();

          this.$vToastify.success(message, "¡Éxito!");

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error(message, "¡Error!");
        }

      }

    }
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
    }, 400);
  },
  watch: {
    data: function (_new) {
      if (_new) {
        this.dataAux = _new;
        this.acuerdoLineaArreglo = [] ;
        this.tarifasRecargosRowSelected = [] ;
        this.generarBotonesAcciones();
      }
    },
    rowsSelected: function (_new) { 
      if(_new.length > 0) {
        this.inactiveButton.deleteSelected = false;
      } else {
        this.inactiveButton.deleteSelected = true;
      }
    },
  },
};
</script>

<style lang="scss">
  .header-btn-actions {
    // background-color: red;
    display: flex;
    justify-content: space-evenly ;
    // background-color: aqua;
  }

  .delete-btn {
    margin-left: 8.5px;
    margin-top: 7.7px;

    &:hover {
        margin-bottom: 7.7px;
    }
  }
</style>
